import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"

export const BoosterSavingsBg = styled(Flex)`
  background-color: ${({theme}) => `${theme.colors.secondary2_50}`};
  border-radius: ${({theme}) => `${theme.border.radius.large}`};
`
